package com.fantasytenis.shared.domain.notifications.usecases

import com.fantasytenis.shared.core.utils.SharedData
import com.fantasytenis.shared.domain.notifications.NotificationsRepository

/**
 * Use case for fetching unread notification count.
 * Updates SharedData.unreadNotificationCount.
 */
class GetUnreadCountUseCase(
    private val repository: NotificationsRepository
) {
    /**
     * Fetch unread count and update SharedData.
     */
    suspend operator fun invoke(): Result<Int> = runCatching {
        val count = repository.getUnreadCount()
        SharedData.unreadNotificationCount.value = count
        count
    }
}
